import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { borderRadii } from '../../app/spacing';
import { gray, red } from '@kizen/kds/Colors';

export default styled.div`
  position: relative;

  ${({ addBorder }) =>
    addBorder &&
    css`
      border-radius: ${borderRadii.small};
      border: 1px solid ${gray['gray-500']};
    `};
  // 230 is a nice looking minimum
  ${({ enableResize, minHeight, minWidth = 0 }) =>
    enableResize &&
    css`
      height: ${minHeight ||
      30}px; // arbitury value that looks right to stop the resize going to small
      min-height: ${minHeight ||
      30}px; // arbitury value that looks right to stop the resize going to small
      resize: both;
      overflow-x: hidden;

      max-width: 100%;
      ${minWidth &&
      css`
        min-width: ${minWidth}px;
      `}
    `}
  ${({ error }) =>
    error &&
    css`
      &&,
      &&:hover {
        border-radius: ${borderRadii.small};
        border: 1px solid ${red['red-500']};
      }
    `}
`;
